import {Color} from "three";
import * as THREE from "three";

function generateTexture() {

    const canvas = document.createElement( 'canvas' );
    canvas.width = 2;
    canvas.height = 2;

    const context = canvas.getContext( '2d' );
    context.fillStyle = 'white';
    context.fillRect( 0, 1, 2, 1 );

    return canvas;

}

//const texture = new THREE.CanvasTexture( generateTexture() );

export const MATERIAL_PROPS_DB = [


    {
        materialName: "GlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `GlassMat-MPM`,
                color: new Color( 0.29119921875000004, 0.5729965745192305, 0.8 ),
                emissive: new THREE.Color(0.20969663085937498, 0.21999999999999997, 0.21999999999999997),
                metalness: .01,
                roughness: 0,
                // alphaMap: texture,
                // alphaTest: 0.5,
                //envMap: envMap, //this.backgroundMap,
                envMapIntensity: 0.5,
                depthWrite: false,
                transmission: 1, // use material.transmission for glass materials
                opacity: 0.4, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true,
                //ior: 1.5,
                //specularIntensity: 1,
                //specularColor: 0xffffff,
                //side: THREE.DoubleSide,
                //alphaMap: texture,
                toneMapped: true,
            });
        },
    },





    {
        materialName:"FloorMat",
        aOIntensity:0.8218328832168038,

        envMapIntensity:3.640456277737683,


        roughness:0.42,
        // toneMapped:'N',

    },



    /* {
         materialName: "W01EP01G001_mat",
         convertToBasicMaterial: 'Y',
         toneMapped:'N',

     },*/

    {
        materialName: "PanelsOnGridEntrenceFrontMat",
        // convertToBasicMaterial: 'Y',
        toneMapped:'N',
        // aOIntensity:0.05,

    },
    {
        materialName: "WallText_UVT2",
        convertToBasicMaterial: 'Y',
        // toneMapped:'N',


    },






    /*{
        materialName:"ceiling_southW_white_mat",
        aOIntensity:0.75,
        // aOIntensity:0.05 ,
        envMapIntensity:3.1,
        //convertToBasicMaterial: 'Y',
        //toneMapped:'N',
    },*/
    {
        materialName:"ceiling_southW_white_mat",
      /*  aOIntensity:0.75,
        envMapIntensity:5.0204133925521015,
        toneMapped:'Y',*/

        aOIntensity:0.4461052271950803,
        envMapIntensity:1.0409121967885206,

    },
    {
        materialName:"ManualTexture_01",
        // aOIntensity:0.7562538705271811,
        /*  aOIntensity:0.79 ,
          envMapIntensity:1.59,*/
        convertToBasicMaterial: 'Y',
        toneMapped:'N',
    },
    {
        materialName:"ReceptionTableMat",
        aOIntensity:0.3730713141740106,

    },
    {
        materialName:"ReceptionBigSofaMat",
        aOIntensity:0.8197745630296611,

    },
    {
        materialName:"CoffeTable01Mat",
        aOIntensity:0.8197745630296611,

    },

    {
        materialName:"InsidePillarMat",
        aOIntensity:0.8201176299193762,

        envMapIntensity:0.05091482087285474,
        toneMapped:'N',

    },
    {
        materialName:"Floor_mat",
        // aOIntensity:0.82,
        // envMapIntensity:1.8,
        // // convertToBasicMaterial: 'Y',
        //
        // toneMapped:'Y',
        // roughness:0.55,
        // metalness:0.3265923427999546,

        aOIntensity:0.774086094977793,
        envMapIntensity:1.3470276733857192,
        roughness:0.55,
        metalness:0.3265923427999546,
        toneMapped:'N',

    },
    /* {
         materialName:"Floor_mat",
         aOIntensity:0.5117014007516227,

         envMapIntensity:0.27562350529552443,
         roughness:0.36735565425350186,
         metalness:0.19243252476938846,
         toneMapped:'Y',
         color:
             new Color( 0.45999999999999996, 0.4204328125, 0.4204328125 ),
     },*/
    {
        materialName: "FrontDeskTextMat",
        aOIntensity: 0.9159132690076687,
    },

    {
        materialName: "All_steel_mat",
        aOIntensity: 0.5327307126544983,
        envMapIntensity:4.52137797832651,
    },
    {
        materialName:"ArchFenceMat",
        // aOIntensity:0.4369350735662057,
        // toneMapped:'N',
        aOIntensity:1.0,

        envMapIntensity:0.01,

        roughness:1,
        toneMapped:'N',
    },
    {
        materialName: "CeilingMat",
       //  aOIntensity: 0.3,
       //  toneMapped:'N',
       //  envMapIntensity: 0.8,
       // // convertToBasicMaterial: 'Y',
        aOIntensity:0.3149128800819952,
        envMapIntensity:0.7347967201913221,
    },
    {
        materialName: "semiDarkGlassMat",
        toneMapped:'N',
        convertToBasicMaterial: 'Y',
    },

    {
        materialName:"DoorWood",
        aOIntensity:0.4688669532623032,

        toneMapped:'N',

    },

    {
        materialName: "chairTableMat",
        aOIntensity:0.6604582314388885,
    },

    {
        materialName: "StairsFloorMat",
        aOIntensity: 0.8,
    },
    {
        materialName: "HDRIMaterial",
        toneMapped:'N',
    },
    {
        materialName:"Floor_outside_mat",
        aOIntensity:0.7243219908310835,

        envMapIntensity:1.01951517165448,

        roughness:0.3691681823947513,
        metalness:0.48625174128044224,

    },

    {
        materialName:"LongChair01FabricMat",
        aOIntensity:0.9159132690076687,
        envMapIntensity:0,
        toneMapped:'N',

    },


    {
        materialName:"defaultMat",
        // aOIntensity:1.1,
        //envMapIntensity:3.3,
        toneMapped:'Y',
        convertToBasicMaterial: 'Y',

    },
    {
        materialName:"TableLampTop",
        emmisiveColor: new THREE.Color(0xC79C68),
        emmissiveIntensity:1.9,
        toneMapped:'N',
    },
    {
        materialName: "ceilingLightMat2",
        aOIntensity: 0.6285263517427909,
    },



    {
        materialName:"I_UV_04",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },
    {
        materialName:"I_UV_14",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },
    {
        materialName:"I_UV_15",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },
    {
        materialName:"I_UV_16",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },
    {
        materialName:"I_UV_17",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },
    {
        materialName:"I_UV_18",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },

    {
        materialName:"I_UV_19",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },

    {
        materialName:"I_UV_20",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },
    {
        materialName:"I_UV_21",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },
    {
        materialName:"I_UV_22",
        toneMapped:'N',
        convertToBasicMaterial: 'Y'
    },
    {
        materialName:"Bookmat",
        toneMapped:'N',
       convertToBasicMaterial: 'Y'
    },




    /*

{
 materialName:"CeilingMat",
aOIntensity:0.3149128800819952,
envMapIntensity:0.7347967201913221,
 },
{
 materialName:"Floor_mat",
aOIntensity:0.774086094977793,
envMapIntensity:1.3470276733857192,
roughness:0.55,
metalness:0.3265923427999546,
toneMapped:'N',
 },
{
 materialName:"ceiling_southW_white_mat",
aOIntensity:0.4461052271950803,
envMapIntensity:1.0409121967885206,
 },



    */



]
